define('plugin/social-gallery/view/SocialGalleryItemView',['require','plugin/social-gallery/view/SocialGalleryModuleItemView'],function (require) {

    //var LayoutView = require('lib/view/LayoutView');
    var SocialGalleryModuleItemView = require('plugin/social-gallery/view/SocialGalleryModuleItemView');

    /**
     * Gallery item view
     *
     * @class SocialGalleryItemView
     */
    return SocialGalleryModuleItemView.extend({

        template: '#social_gallery_item_view'

    });

});
